import { createSlice } from "@reduxjs/toolkit";
import * as BookingApi from "../api/booking";

const bookingDetail = createSlice({
  name: "bookingDetail",
  initialState: {
    loading: false,
    error: null,
    booking: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getDetailSuccess: (state, action) => {
      state.booking = action.payload;
      state.loading = false;
    },
  },
});

export const getBookingDetail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await BookingApi.getBookingById(id);
    dispatch(getDetailSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = bookingDetail;
export const { setLoading, setError, getDetailSuccess } = actions;
export default reducer;
